export const setFileTemplate = (state, { payload }) => {
    if (payload) for (let key in payload) state[key] = payload[key];
};
